import { NgModule } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AppRoutes } from './app.routes'
import { BreadcrumbModule } from 'primeng/breadcrumb'
import { CardModule } from 'primeng/card'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { InputTextModule } from 'primeng/inputtext'
import { MessagesModule } from 'primeng/messages'
import { PanelModule } from 'primeng/panel'
import { PanelMenuModule } from 'primeng/panelmenu'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { ToastModule } from 'primeng/toast'
import { TooltipModule } from 'primeng/tooltip'

import { ACE_CONFIG, AceConfigInterface } from 'ngx-ace-wrapper'

import { AppComponent } from './app.component'
import { BreadcrumbComponent } from './layout/breadcrumb/breadcrumb.component'
import { TopBarComponent } from './layout/topbar/topbar.component'
import { LayoutComponent } from './layout/layout/layout.component'
import { UserMenuComponent } from './layout/user-menu/user-menu.component'

import { TokenInterceptor } from 'src/token.interceptor'
import { HttpErrorRepsonseInterceptor } from 'src/http-error-repsonse.interceptor'
import { NgxPermissionsModule } from 'ngx-permissions'
import { DigitOnlyModule } from '@uiowa/digit-only'
import { RouterModule } from '@angular/router'
import { MenuComponent } from './layout/menu/menu.component'
import { SidebarComponent } from './layout/sidebar/sidebar.component'
import { FooterComponent } from './layout/footer/footer.component'
import { LocationStrategy, HashLocationStrategy } from '@angular/common'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import {
  JmlLibConfig,
  JmlLibModule,
  RootStoreModule,
  AuthModule,
  HttpHeadersService,
  DiagramsModule,
  BreadcrumbService,
  EditComponentsModule
} from '@dot-it/jml-lib'
import { IconPickerModule } from 'ngx-icon-picker'
import { KeyFilterModule } from 'primeng/keyfilter'

import 'chartjs-adapter-luxon' // this is needed for providing the time axis feature in charts

const DEFAULT_ACE_CONFIG: AceConfigInterface = {
  tabSize: 2,
  fontSize: '16px'
}

import { LOCALE_ID } from '@angular/core'
import { registerLocaleData } from '@angular/common'
import localeDe from '@angular/common/locales/de'
import { FileSaverModule } from 'ngx-filesaver'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { environment } from '@env/environment'
import { CustomLibRoutingModule, CustomLibModule } from '@dot-it/custom-lib'
import { CustomLibRoutesModule } from './custom-lib-routes.module'
import { ButtonModule } from 'primeng/button'
import { LayoutFullscreenComponent } from './layout-fullscreen/layout-fullscreen.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { DragDropModule } from '@angular/cdk/drag-drop'

registerLocaleData(localeDe)

@NgModule({
  imports: [
    AppRoutes,
    AuthModule,
    BreadcrumbModule,
    BrowserAnimationsModule,
    ButtonModule,
    CardModule,
    ConfirmDialogModule,
    DiagramsModule,
    DigitOnlyModule,
    FileSaverModule,
    FormsModule,
    HttpClientModule,
    IconPickerModule,
    InputTextModule,
    KeyFilterModule,
    MessagesModule,
    NgxPermissionsModule.forRoot(),
    PanelMenuModule,
    PanelModule,
    ReactiveFormsModule,
    RootStoreModule,
    RouterModule,
    ScrollPanelModule,
    ToastModule,
    TooltipModule,
    JmlLibModule.forRoot(<JmlLibConfig>{
      production: environment.production,
      loadPlayground: environment.loadPlayground,
      baseUrl: environment.baseUrl,
      companyName: environment.companyName,
      companyStreet: environment.companyStreet,
      companyCity: environment.companyCity,
      companyPhone: environment.companyPhone,
      companyEmail: environment.companyEmail
    }),
    CustomLibModule,
    CustomLibRoutingModule,
    CustomLibRoutesModule,
    FontAwesomeModule,
    EditComponentsModule,
    DragDropModule
  ],
  declarations: [
    AppComponent,
    LayoutComponent,
    BreadcrumbComponent,
    TopBarComponent,
    UserMenuComponent,
    MenuComponent,
    SidebarComponent,
    FooterComponent,
    LayoutFullscreenComponent
  ],
  providers: [
    { provide: BreadcrumbService, useClass: BreadcrumbService },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorRepsonseInterceptor, multi: true },

    BreadcrumbService,
    HttpHeadersService,
    { provide: ACE_CONFIG, useValue: DEFAULT_ACE_CONFIG },
    { provide: LOCALE_ID, useValue: 'de-DE' }
  ],

  bootstrap: [AppComponent]
})
export class AppModule {}
